module.exports = __webpack_public_path__ + "static/media/francisco.c85a8a4f.jpg";